import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import dictionaryData from '../dictionary/dictionaryjson';
import '../styles/mosaicExplodeStyles.css';

/*---------------------------------------------------
  Shared light‑box component (desktop & mobile)
---------------------------------------------------*/
const LightboxPortal = ({ show, onClose }) =>
  ReactDOM.createPortal(
    <div className="mobileLightbox" onClick={onClose}>
      <button className="closeLightbox" onClick={onClose}>&times;</button>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <img
          src={show.img_URL}
          alt={show.title}
          className="hoverImage"
          style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
        />
        <div className="hoverInfo">
          <h3>{show.title}</h3>
          <p>{show.description}</p>
          {show.show_URL && (
            <a href={show.show_URL} target="_blank" rel="noopener noreferrer">
              View Series
            </a>
          )}
        </div>
      </div>
    </div>,
    document.body
  );

/*---------------------------------------------------
  Mosaic grid
---------------------------------------------------*/
const MosaicExplodeGrid = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [columns, setColumns] = useState(getColumns(window.innerWidth));

  // utility to match your media‑query column counts
  function getColumns(width) {
    if (width <= 768) return 3;
    if (width <= 1100) return 4;
    return 6;
  }

  // adjust column count on resize (used only for CSS row height if needed later)
  useEffect(() => {
    const onResize = () => setColumns(getColumns(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const posters = dictionaryData.filter((d) => d.published && d.poster_URL);

  return (
    <section className="poster-mosaic-grid">
      {posters.map((item, idx) => (
        <div
          key={idx}
          className="poster-tile"
          onClick={() => setActiveIndex(idx)}
        >
          <img src={item.poster_URL} alt={item.title} loading="lazy" />
        </div>
      ))}

      {/* light‑box for ALL viewports */}
      {activeIndex !== null && (
        <LightboxPortal
          show={posters[activeIndex]}
          onClose={() => setActiveIndex(null)}
        />
      )}
    </section>
  );
};

export default MosaicExplodeGrid;
